export default __webpack_public_path__ + "static/media/trener4.b9b2829c.png";